<template>
    <div class="lavelbar-content" v-show="this.$route.path === '/welcome' ? false : true">
        <div class="house">
            <div @click="toLayout()" class="img-house"><img src="../../assets/imgs/Home.png" alt=""></div>
            <span>{{$t('index.Location')}}：</span>
        </div>
        <el-breadcrumb class="app-levelbar" separator="/">
            <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path">
                <span v-if='item.redirect==="noredirect"||index==levelList.length-1' class="no-redirect">{{item.name}}</span>
                <router-link v-else :to="item.redirect||item.path">{{item.name}}</router-link>
            </el-breadcrumb-item>

        </el-breadcrumb>
    </div>

</template>

<script>
export default {
    created() {
        this.getBreadcrumb();
    },
    data() {
        return {
            levelList: null
        };
    },
    mounted() {
        //	let breadcrumb__separator = document.querySelector('.el-breadcrumb__separator');
        //		breadcrumb__separator.innerHTML = "＞";
        //		console.log(this.$route);
    },
    methods: {
        getBreadcrumb() {
            let matched = this.$route.matched.filter(item => item.name);
            const first = matched[0];
            // if (first && (first.name !== '首页' || first.path !== '')) {
            //   matched = [{ name: '首页', path: '/' }].concat(matched)
            // }
            this.levelList = matched;
        },
        toLayout() {
            this.$router.push({ path: "/" });
        }
    },
    watch: {
        $route() {
            this.getBreadcrumb();
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.lavelbar-content {
    height: 50px;
    line-height: 50px;
}
.house {
    display: inline-block;
    margin-left: 35px;
    font-size: 16px;
    color: #006ab6;
    .img-house {
        width: 16px;
        height: 16px;
        display: inline-block;
        cursor: pointer;
    }
    img {
        vertical-align: text-bottom;
    }
}

.app-levelbar.el-breadcrumb {
    height: 13px;
    display: inline-block;
    font-size: 16px;
    .no-redirect {
        color: #006ab6;
        cursor: text;
    }
}
.el-breadcrumb__item__inner,
.el-breadcrumb__item__inner a {
    color: #006ab6;
}
</style>



// WEBPACK FOOTER //
// Levelbar.vue?59ec5646